<template>
    <svg
        width="660"
        height="327"
        viewBox="0 0 660 327"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 145C32 138.373 37.3726 133 44 133H314C320.627 133 326 138.373 326 145V315C326 321.627 320.627 327 314 327H44C37.3726 327 32 321.627 32 315V145Z"
            fill="var(--et-colors-card-background)"
            stroke="var(--et-colors-border)"
        />
        <path
            d="M334 155C334 148.373 339.373 143 346 143H616C622.627 143 628 148.373 628 155V305C628 311.627 622.627 317 616 317H346C339.373 317 334 311.627 334 305V155Z"
            fill="var(--et-colors-card-background)"
            stroke="var(--et-colors-border)"
        />
        <path
            d="M69 310.125C80.1147 310.125 89.125 301.115 89.125 290C89.125 278.885 80.1147 269.875 69 269.875C57.8853 269.875 48.875 278.885 48.875 290C48.875 301.115 57.8853 310.125 69 310.125Z"
            fill="#F2F4F7"
        />
        <path
            d="M371 300.125C382.115 300.125 391.125 291.115 391.125 280C391.125 268.885 382.115 259.875 371 259.875C359.885 259.875 350.875 268.885 350.875 280C350.875 291.115 359.885 300.125 371 300.125Z"
            fill="#F2F4F7"
        />
        <path
            d="M69 310.125C80.1147 310.125 89.125 301.115 89.125 290C89.125 278.885 80.1147 269.875 69 269.875C57.8853 269.875 48.875 278.885 48.875 290C48.875 301.115 57.8853 310.125 69 310.125Z"
            stroke="white"
            stroke-width="1.75"
        />
        <path
            d="M371 300.125C382.115 300.125 391.125 291.115 391.125 280C391.125 268.885 382.115 259.875 371 259.875C359.885 259.875 350.875 268.885 350.875 280C350.875 291.115 359.885 300.125 371 300.125Z"
            stroke="white"
            stroke-width="1.75"
        />
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="36"
            font-weight="600"
            letter-spacing="-1px"
        >
            <tspan x="233.326" y="58.2">Wall of love</tspan>
        </text>
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre; opacity: 0.8"
            font-family="Geist"
            font-size="16"
            letter-spacing="0em"
        >
            <tspan x="242.047" y="90.2001">Our customers&#39; reviews.</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            font-weight="500"
            letter-spacing="0em"
        >
            <tspan x="98" y="293.9">Renee Hilpert</tspan>
        </text>
        <path
            d="M55.6836 149.519C55.9747 148.827 56.9664 148.827 57.2576 149.519L58.9761 153.601C59.0989 153.892 59.3765 154.091 59.695 154.117L64.1557 154.47C64.9114 154.53 65.2179 155.461 64.642 155.949L61.2436 158.825C61.0008 159.03 60.8948 159.353 60.9689 159.66L62.0072 163.96C62.1831 164.688 61.3809 165.264 60.7338 164.874L56.9149 162.569C56.6421 162.405 56.299 162.405 56.0263 162.569L52.2073 164.874C51.5603 165.264 50.758 164.688 50.9339 163.96L51.9722 159.66C52.0464 159.353 51.9404 159.03 51.6976 158.825L48.2991 155.949C47.7233 155.461 48.0297 154.53 48.7855 154.47L53.2461 154.117C53.5647 154.091 53.8423 153.892 53.965 153.601L55.6836 149.519Z"
            fill="#F4C546"
        />
        <path
            d="M76.0129 149.519C76.3041 148.827 77.2958 148.827 77.5869 149.519L79.3054 153.601C79.4282 153.892 79.7058 154.091 80.0244 154.117L84.485 154.47C85.2408 154.53 85.5472 155.461 84.9714 155.949L81.5729 158.825C81.3302 159.03 81.2241 159.353 81.2983 159.66L82.3366 163.96C82.5125 164.688 81.7102 165.264 81.0632 164.874L77.2442 162.569C76.9715 162.405 76.6284 162.405 76.3556 162.569L72.5367 164.874C71.8896 165.264 71.0873 164.688 71.2632 163.96L72.3016 159.66C72.3757 159.353 72.2697 159.03 72.027 158.825L68.6284 155.949C68.0526 155.461 68.3591 154.53 69.1148 154.47L73.5755 154.117C73.8941 154.091 74.1716 153.892 74.2944 153.601L76.0129 149.519Z"
            fill="#F4C546"
        />
        <path
            d="M96.3423 149.519C96.6334 148.827 97.6251 148.827 97.9163 149.519L99.6348 153.601C99.7576 153.892 100.035 154.091 100.354 154.117L104.814 154.47C105.57 154.53 105.877 155.461 105.301 155.949L101.902 158.825C101.66 159.03 101.553 159.353 101.628 159.66L102.666 163.96C102.842 164.688 102.04 165.264 101.393 164.874L97.5736 162.569C97.3008 162.405 96.9577 162.405 96.685 162.569L92.866 164.874C92.219 165.264 91.4167 164.688 91.5926 163.96L92.6309 159.66C92.7051 159.353 92.5991 159.03 92.3563 158.825L88.9578 155.949C88.3819 155.461 88.6884 154.53 89.4442 154.47L93.9048 154.117C94.2234 154.091 94.501 153.892 94.6237 153.601L96.3423 149.519Z"
            fill="#F4C546"
        />
        <path
            d="M116.672 149.519C116.963 148.827 117.954 148.827 118.246 149.519L119.964 153.601C120.087 153.892 120.364 154.091 120.683 154.117L125.144 154.47C125.899 154.53 126.206 155.461 125.63 155.949L122.232 158.825C121.989 159.03 121.883 159.353 121.957 159.66L122.995 163.96C123.171 164.688 122.369 165.264 121.722 164.874L117.903 162.569C117.63 162.405 117.287 162.405 117.014 162.569L113.195 164.874C112.548 165.264 111.746 164.688 111.922 163.96L112.96 159.66C113.034 159.353 112.928 159.03 112.686 158.825L109.287 155.949C108.711 155.461 109.018 154.53 109.774 154.47L114.234 154.117C114.553 154.091 114.83 153.892 114.953 153.601L116.672 149.519Z"
            fill="#F4C546"
        />
        <path
            d="M137.001 149.519C137.292 148.827 138.284 148.827 138.575 149.519L140.293 153.601C140.416 153.892 140.694 154.091 141.012 154.117L145.473 154.47C146.229 154.53 146.535 155.461 145.959 155.949L142.561 158.825C142.318 159.03 142.212 159.353 142.286 159.66L143.325 163.96C143.501 164.688 142.698 165.264 142.051 164.874L138.232 162.569C137.959 162.405 137.616 162.405 137.344 162.569L133.525 164.874C132.878 165.264 132.075 164.688 132.251 163.96L133.29 159.66C133.364 159.353 133.258 159.03 133.015 158.825L129.616 155.949C129.041 155.461 129.347 154.53 130.103 154.47L134.564 154.117C134.882 154.091 135.16 153.892 135.282 153.601L137.001 149.519Z"
            fill="#F4C546"
        />
        <path
            d="M357.684 159.519C357.975 158.827 358.966 158.827 359.258 159.519L360.976 163.601C361.099 163.892 361.376 164.091 361.695 164.117L366.156 164.47C366.911 164.53 367.218 165.461 366.642 165.949L363.244 168.825C363.001 169.03 362.895 169.353 362.969 169.66L364.007 173.96C364.183 174.688 363.381 175.264 362.734 174.874L358.915 172.569C358.642 172.405 358.299 172.405 358.026 172.569L354.207 174.874C353.56 175.264 352.758 174.688 352.934 173.96L353.972 169.66C354.046 169.353 353.94 169.03 353.698 168.825L350.299 165.949C349.723 165.461 350.03 164.53 350.785 164.47L355.246 164.117C355.565 164.091 355.842 163.892 355.965 163.601L357.684 159.519Z"
            fill="#F4C546"
        />
        <path
            d="M378.013 159.519C378.304 158.827 379.296 158.827 379.587 159.519L381.305 163.601C381.428 163.892 381.706 164.091 382.024 164.117L386.485 164.47C387.241 164.53 387.547 165.461 386.971 165.949L383.573 168.825C383.33 169.03 383.224 169.353 383.298 169.66L384.337 173.96C384.512 174.688 383.71 175.264 383.063 174.874L379.244 172.569C378.971 172.405 378.628 172.405 378.356 172.569L374.537 174.874C373.89 175.264 373.087 174.688 373.263 173.96L374.302 169.66C374.376 169.353 374.27 169.03 374.027 168.825L370.628 165.949C370.053 165.461 370.359 164.53 371.115 164.47L375.575 164.117C375.894 164.091 376.172 163.892 376.294 163.601L378.013 159.519Z"
            fill="#F4C546"
        />
        <path
            d="M398.342 159.519C398.633 158.827 399.625 158.827 399.916 159.519L401.635 163.601C401.758 163.892 402.035 164.091 402.354 164.117L406.814 164.47C407.57 164.53 407.877 165.461 407.301 165.949L403.902 168.825C403.66 169.03 403.553 169.353 403.628 169.66L404.666 173.96C404.842 174.688 404.04 175.264 403.393 174.874L399.574 172.569C399.301 172.405 398.958 172.405 398.685 172.569L394.866 174.874C394.219 175.264 393.417 174.688 393.593 173.96L394.631 169.66C394.705 169.353 394.599 169.03 394.356 168.825L390.958 165.949C390.382 165.461 390.688 164.53 391.444 164.47L395.905 164.117C396.223 164.091 396.501 163.892 396.624 163.601L398.342 159.519Z"
            fill="#F4C546"
        />
        <path
            d="M418.672 159.519C418.963 158.827 419.954 158.827 420.246 159.519L421.964 163.601C422.087 163.892 422.364 164.091 422.683 164.117L427.144 164.47C427.899 164.53 428.206 165.461 427.63 165.949L424.232 168.825C423.989 169.03 423.883 169.353 423.957 169.66L424.995 173.96C425.171 174.688 424.369 175.264 423.722 174.874L419.903 172.569C419.63 172.405 419.287 172.405 419.014 172.569L415.195 174.874C414.548 175.264 413.746 174.688 413.922 173.96L414.96 169.66C415.034 169.353 414.928 169.03 414.686 168.825L411.287 165.949C410.711 165.461 411.018 164.53 411.774 164.47L416.234 164.117C416.553 164.091 416.83 163.892 416.953 163.601L418.672 159.519Z"
            fill="#F4C546"
        />
        <path
            d="M439.001 159.519C439.292 158.827 440.284 158.827 440.575 159.519L442.293 163.601C442.416 163.892 442.694 164.091 443.012 164.117L447.473 164.47C448.229 164.53 448.535 165.461 447.959 165.949L444.561 168.825C444.318 169.03 444.212 169.353 444.286 169.66L445.325 173.96C445.501 174.688 444.698 175.264 444.051 174.874L440.232 172.569C439.959 172.405 439.616 172.405 439.344 172.569L435.525 174.874C434.878 175.264 434.075 174.688 434.251 173.96L435.29 169.66C435.364 169.353 435.258 169.03 435.015 168.825L431.616 165.949C431.041 165.461 431.347 164.53 432.103 164.47L436.564 164.117C436.882 164.091 437.16 163.892 437.282 163.601L439.001 159.519Z"
            fill="#F4C546"
        />
        <path
            d="M304 181H54C50.6863 181 48 183.686 48 187C48 190.314 50.6863 193 54 193H304C307.314 193 310 190.314 310 187C310 183.686 307.314 181 304 181Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M267 201H54C50.6863 201 48 203.686 48 207C48 210.314 50.6863 213 54 213H267C270.314 213 273 210.314 273 207C273 203.686 270.314 201 267 201Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M283 221H54C50.6863 221 48 223.686 48 227C48 230.314 50.6863 233 54 233H283C286.314 233 289 230.314 289 227C289 223.686 286.314 221 283 221Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M164 241H54C50.6863 241 48 243.686 48 247C48 250.314 50.6863 253 54 253H164C167.314 253 170 250.314 170 247C170 243.686 167.314 241 164 241Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M606 191H356C352.686 191 350 193.686 350 197C350 200.314 352.686 203 356 203H606C609.314 203 612 200.314 612 197C612 193.686 609.314 191 606 191Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M606 211H356C352.686 211 350 213.686 350 217C350 220.314 352.686 223 356 223H606C609.314 223 612 220.314 612 217C612 213.686 609.314 211 606 211Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M466 231H356C352.686 231 350 233.686 350 237C350 240.314 352.686 243 356 243H466C469.314 243 472 240.314 472 237C472 233.686 469.314 231 466 231Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M63 295.833C64.5572 294.182 66.6713 293.167 69 293.167C71.3287 293.167 73.4428 294.182 75 295.833M365 285.833C366.557 284.182 368.671 283.167 371 283.167C373.329 283.167 375.443 284.182 377 285.833M72 287.5C72 289.157 70.6569 290.5 69 290.5C67.3431 290.5 66 289.157 66 287.5C66 285.843 67.3431 284.5 69 284.5C70.6569 284.5 72 285.843 72 287.5ZM374 277.5C374 279.157 372.657 280.5 371 280.5C369.343 280.5 368 279.157 368 277.5C368 275.843 369.343 274.5 371 274.5C372.657 274.5 374 275.843 374 277.5Z"
            stroke="#101828"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            font-weight="500"
            letter-spacing="0em"
        >
            <tspan x="400" y="283.9">Isaac Schiller</tspan>
        </text>
        <path
            d="M15 224L9 230L15 236M645 236L651 230L645 224"
            stroke="#667085"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
<script setup lang="ts"></script>
